import shallowEqual from 'fbjs/lib/shallowEqual';

export default shallowEqual;